'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.addMilliseconds;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/addMilliseconds.js
// module id = 469
// module chunks = 0